// extracted by mini-css-extract-plugin
var _1 = "GlobalModal__checkText--UpGMk";
var _2 = "GlobalModal__checkbox--e11Zk";
var _3 = "GlobalModal__darkerBackdrop--dvCvH";
var _4 = "GlobalModal__errorBadURL--gx7yE";
var _5 = "GlobalModal__errorImage--fjLqn ErrorMessage__imageBase--SmEk7";
var _6 = "GlobalModal__errorMessage--PhURi ErrorMessage__messageBase--GMVXk";
var _7 = "GlobalModal__fullScreenModal--E2bER";
var _8 = "GlobalModal__wrapper--NGO7l";
export { _1 as "checkText", _2 as "checkbox", _3 as "darkerBackdrop", _4 as "errorBadURL", _5 as "errorImage", _6 as "errorMessage", _7 as "fullScreenModal", _8 as "wrapper" }
